import React, { memo, useState, useRef, useEffect } from "react";
import danger_image from "../img/danger.png";
import no_danger_image from "../img/no_danger.png";

const statusOptions = {
  danger: danger_image,
  no_danger: no_danger_image,
};

export default memo(({ value, onValueChange, stopEditing }) => {
  const [isOpen, setIsOpen] = useState(false);
  const refContainer = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (refContainer.current && !refContainer.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const onClick = (newValue) => {
    var value_to_save = newValue==="danger" ? true : false;
    onValueChange(value_to_save);
    setIsOpen(false);
    //stopEditing();
  };

  const boxStyle = {
    position: "relative",
    borderRadius: 5,
    border: "1px solid grey",
    backgroundColor: "#ffffff",
    padding: 10,
    textAlign: "center",
    height: "40px",
    display: "inline-flex",
    alignItems: "center",
    cursor: "pointer",
  };

  const dropdownStyle = {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    border: "1px solid grey",
    borderRadius: 10,
    padding: 10,
    display: isOpen ? "flex" : "none",
    flexDirection:"column",
    justifyContent: "center",
    gap: 10,
  };

  return (
    <div ref={refContainer} style={{ position: "relative", display: "inline-block" }}>
      <div style={boxStyle} onClick={() => setIsOpen((prev) => !prev)}>
        <img src={statusOptions[value?"danger":"no_danger"]} style={{ width: "20px", height: "20px" }} alt={value} />
        <span style={{ marginLeft: 10, fontSize: "20px" }}>▼</span>
      </div>
      <div style={dropdownStyle}>
        {Object.entries(statusOptions).map(([key, imgSrc]) => (
          <img
            key={key}
            src={imgSrc}
            style={{ width: "20px", height: "20px", cursor: "pointer" }}
            onClick={() => onClick(key)}
            alt={key}
          />
        ))}
      </div>
    </div>
  );
});
